// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig  = {
    apiKey: "AIzaSyBqKBHqNFKg4XxlLHStUMNR2nZm6sRBOkM",
    authDomain: "ema-john-2cea5.firebaseapp.com",
    projectId: "ema-john-2cea5",
    storageBucket: "ema-john-2cea5.appspot.com",
    messagingSenderId: "669982641875",
    appId: "1:669982641875:web:5854fb5dce9ff9fb79ce26",
    measurementId: "G-43WJN27WDQ"
  };

  export default firebaseConfig  ;